import { AvatarDropdown as CoreAvatarDropdown } from '@zhiyue/core';
import { BizAppConfig } from 'config/application.manifest';
import React from 'react';

const AvatarDropdown: React.FC = () => {
  return (
    <CoreAvatarDropdown
      appId={BizAppConfig.appSsoClientId}
      personalCenterUrl={BizAppConfig.appPersonalCenterUrl}
      tenantManagementUrl={BizAppConfig.appTenantManagementUrl}
      // 传空串而非 undefined：core 在取不到该属性时会回落到内置的默认工作台地址
      workbenchUrl={
        BizAppConfig.appWorkbenchEntryVisible
          ? BizAppConfig.appWorkbenchUrl
          : ''
      }
      openPlatformUrl={BizAppConfig.appOpenPlatformUrl}
    />
  );
};

export default AvatarDropdown;
